import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * オンライン面会スケジュール API 操作クラス
 */
export default class ReservableOnlineSchedules {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET ReservableOnlineSchedules
   */
  public async get(userStore: LoginUser, groupId: number, residentId: number, year: string, month: string): Promise<Array<ReservableOnlineSchedulesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      groupId: groupId,
      residentId: residentId,
      year: year,
      month: month
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ReservableOnlineSchedules, formatParams);
    const response = await this.commonService.executeGet<Array<ReservableOnlineSchedulesGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

/**
 * ### オンライン面会スケジュールモデル
 */
export interface ReservableOnlineSchedulesGetModel {
  /** 施設ID */
  facilityId: number;
  /** 予約可能日時ソートキー */
  onlineReservationsScheduleSortKey?: string;
  /** 年 */
  year: number;
  /** 月 */
  month: number;
  /** 日 */
  date: number;
  /** 時 */
  hour: number;
  /** 分 */
  min: number;
  /** 予約可能か否か */
  canReservation: boolean;
  /** 予約依頼数 */
  reservationRequestsCount: number;
  /** 登録ユーザーID */
  registerUserId: string;
  /** 登録ユーザー名 */
  registerUserName: string;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** 更新日時 */
  updated: number;
}
